import React, {Component} from "react"
import { withRouteData, Link, Head } from 'react-static'
import './Careers.scss'
import Footer from "./Footer"
import Header from "./Header"

export default withRouteData(({ jobs }) => (
  <div className="careersPage">
    <Head>
      <title>Careers - World Singles Networks | We Make Love</title>
      <link rel="shortcut icon" type="image/x-icon" href="/favicon/favicon.ico"/>
    </Head>
    <Header />

    <section className="careers">
      <div className="middleContainer">
        <div className="contentContainer reachtext">
          <p>come work with us</p>
          <h1>We’re here to do the best work of our careers.</h1>
          <br />
          <p>WorldSingles is about people and we want the best for our team, our customers, and our friends. Our mission is to help people create valuable social connections and we’re making that happen! You’ll want to work with us because you want to make a difference and solve challenging problems. We’re looking for individuals who push themselves and inspire those around them. </p>
          <h2>Open Positions:</h2>
          <ul>
            {jobs.map(job => (
              <li key={job.id}>
                <Link to={`/careers/job/${job.id}/`}>{job.title}</Link>
              </li>
            ))}
          </ul>
          <br />
          <br />
          <br />
          <p>Interested in joining us but not able to find what you are looking for? Let’s talk anyway. Write to us at <a href="mailto:hr@worldsingles.com">hr@worldsingles.com</a></p>
        </div>
      </div>
    </section>

    <Footer />
  </div>
))


// WEBPACK FOOTER //
// /usr/src/app/src/containers/Careers.js